/* Ground
 * 地面オブジェクト.
 */
import * as THREE from "three";
import {Config} from "./View3dConfig";
import {defines, Scene} from "./index";
import * as webcad from "../../webcad";

export class Ground {
    private _geometry: THREE.BufferGeometry;
    private _texture: THREE.Texture;
    private _material: THREE.MeshBasicMaterial; // MeshPhongMaterialだと光源影響を受けて白く反射してしまうため、MeshBasicMaterialだと光源の影響を受けない
    private _mesh: THREE.Mesh;
    public get mesh(): THREE.Mesh { return this._mesh; }

    constructor() {
        this._geometry = new THREE.PlaneGeometry(40, 40, 16, 16);

        THREE.TextureLoader.prototype.crossOrigin = "*";
        const texLoader = new THREE.TextureLoader();
        texLoader.crossOrigin = '';
        this._texture = texLoader.load(this.getGroundTextureUrl());
        this._texture.wrapS = THREE.RepeatWrapping;
        this._texture.wrapT = THREE.RepeatWrapping;
        this._texture.repeat.set(16, 16);

        this._material = new THREE.MeshBasicMaterial();
        this._material.color = new THREE.Color(0x999999);
        this._material.map = this._texture;

        this._mesh = new THREE.Mesh(<THREE.BufferGeometry>(this._geometry), this._material);
        this._mesh.rotation.x = - Math.PI / 2;
        this._mesh.name = defines.DefNames.terrain;

        this._mesh.userData = { type: "Environment" };
    }

    public getGroundTextureUrl(normal?: boolean): string {
        if (normal) return webcad.WebCADGlobal.webcad2Dmanager.assets_url + "texture3d/groundNormal.jpg";
        return webcad.WebCADGlobal.webcad2Dmanager.assets_url + "texture3d/ground.jpg";
    }
    public apply(scene: Scene) {
        scene.me.add(this._mesh);
    }
    public reset(scene: Scene) {
        scene.me.remove(this._mesh);
    }
}
